export default __webpack_public_path__ + "static/media/slider-arrow.1f5183cb.svg";